import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconIconFn = /* @__PURE__ */ createRecipe('radio-icon-icon', {}, [])

const radioOnlyIconIconVariantMap = {}

const radioOnlyIconIconVariantKeys = Object.keys(radioOnlyIconIconVariantMap)

export const radioOnlyIconIcon = /* @__PURE__ */ Object.assign(memo(radioOnlyIconIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconIcon',
  __getCompoundVariantCss__: radioOnlyIconIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconIconVariantKeys,
  variantMap: radioOnlyIconIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconIconVariantKeys)
  },
  getVariantProps: radioOnlyIconIconFn.getVariantProps,
})